export default __webpack_public_path__ + "static/media/forward-button-icon.c5238d72.svg";